<template>
  <v-container fluid class="white py-0 px-3 breadcrumbs-wrapper">
    <v-layout row wrap>
      <v-flex sm6 xs12>
        <div v-if="pageTitle" class="subheading py-2 pl-2">{{pageTitle}}</div>
      </v-flex>
      <v-flex sm6 v-if="breadcrumbs.length" class="hidden-xs-only">
        <v-breadcrumbs divider="/" :justify-end="true">
          <v-breadcrumbs-item v-for="item in breadcrumbs" :key="item.text" :disabled="item.disabled" :to="item.href">
            {{ item.text }}
          </v-breadcrumbs-item>
        </v-breadcrumbs>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  export default {
    name: 'Breadcrumbs',
    computed: {
      breadcrumbs () {
        return this.$store.getters.breadcrumbs
      },
      pageTitle () {
        return this.$store.getters.pageTitle
      }
    }
  }
</script>

<style scoped>
  .v-breadcrumbs {
    padding: 9px 12px;
  }
</style>
